import { v4 } from 'uuid';
import { logger } from './logger';
const tab_id = v4();
const prefix = '__election__';
const name = '__store__';
const open = async (db)=>new Promise((resolve, reject)=>{
        const request = window.indexedDB.open(db);
        request.onsuccess = ()=>resolve(request.result);
        request.onerror = ()=>reject(new Error(`error opening indexedDB: ${request.error}`));
        request.onupgradeneeded = ()=>request.result.createObjectStore(name);
    });
const elected = async (key)=>{
    const db = await open(`${prefix}${key}`);
    const transaction = db.transaction(name, 'readwrite');
    const store = transaction.objectStore(name);
    store.add(true, 'election-completed');
    const result = await new Promise((resolve, reject)=>{
        transaction.oncomplete = ()=>resolve(true);
        transaction.onabort = (event)=>{
            const { error } = event.target;
            if (error.name === 'ConstraintError') {
                resolve(false);
            } else {
                reject(error);
            }
        };
        transaction.onerror = ()=>{
            if (transaction.error != null) {
                reject(transaction.error);
            }
        };
    });
    db.close();
    return result;
};
const endElection = (key)=>{
    try {
        indexedDB.deleteDatabase(prefix + key);
    } catch (error) {
        logger.error("couldn't end election", {
            key,
            tab_id,
            error
        });
    }
};
export const elector = {
    elect: async (key, timeout, handler)=>{
        logger.log('requesting election', {
            key,
            tab_id
        });
        try {
            window.setTimeout(()=>endElection(key), timeout.asMilliseconds());
            if (await elected(key)) {
                logger.log('election won', {
                    key,
                    tab_id
                });
                handler();
            } else {
                logger.log('election lost', {
                    key,
                    tab_id
                });
            }
        } catch (error) {
            logger.error('election failed', {
                key,
                tab_id,
                error
            });
        }
    }
};
